import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PageShell } from '../components/ui/PageHeader';
import { EmptyState } from '../components/ui/States';

/** The department a mistyped link sat under, so the 404 offers a way back into it. */
const AREAS: Record<string, string> = {
  sales: 'Sales',
  csm: 'CSM',
  gtm: 'GTM',
  marketing: 'Marketing',
  finance: 'Finance',
  organizer: 'Organizer',
  resources: 'Resources',
};

/** Any URL no route matches: said plainly, inside the app shell, with a way back. */
export function NotFound() {
  const { pathname } = useLocation();
  const area = pathname.split('/').filter(Boolean)[0] ?? '';
  const areaLabel = AREAS[area];
  useEffect(() => {
    document.title = 'Page not found · SEQUESTO OS';
  }, [pathname]);
  return (
    <PageShell>
      <EmptyState
        title="Page not found"
        description={
          <>
            <span className="block">
              Nothing lives at <span className="font-mono [overflow-wrap:anywhere]">{pathname}</span>.
            </span>
            <span className="block">The link may be old or mistyped.</span>
          </>
        }
        action={
          <div className="flex flex-wrap items-center justify-center gap-4">
            {areaLabel && (
              <Link to={`/${area}`} className="text-body-sm font-medium text-accent hover:underline">
                Go to {areaLabel}
              </Link>
            )}
            <Link to="/" className="text-body-sm font-medium text-accent hover:underline">
              Go to Home
            </Link>
          </div>
        }
      />
    </PageShell>
  );
}
